let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8tqgK"), load("9gJO7"), load("eb06U"), load("2u53D"), load("kPKOV"), load("34R0T")]).then(() => parcelRequire('f2tcq'));